import MainLayout from "@/components/layout/admin/MainLayout.vue";
import AdvancedLaravelVuePaginate from "advanced-laravel-vue-paginate";
import "advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import CONFIG from "@/assets/js/config.js";
import axios from "axios";
import HandlePaginateService from "@/services/HandlePaginateService";
import tinycolor from "tinycolor2";

export default {
  name: "TransactionCategoryList",
  components: {
    MainLayout,
    AdvancedLaravelVuePaginate,
    Loading,
  },

  data() {
    return {
      noDataMsg: CONFIG.NO_DATA_FOUND,
      isLoading: false,
      categoryData: {},
      searchData: {
        category_name: "",
        category_type: null,
        is_active: null,
      },
      searchedData: null,
      searchBtnStatus: false,
      CONFIG,
      currentPage: 1,
    };
  },

  computed: {
    registrationCategoryName() {
      return this.CONFIG.TRANSACTION_CATEGORY.SCHOOL_REGISTRATION_FEE || "School Registration Fee";
    },
  },

  methods: {
    validColor(value) {
        const input = String(value ?? "").trim();
        if (!input) {
            return false;
        }

        const standardHexRegex = /^#([0-9A-Fa-f]{3}){1,2}$/;
        if (!standardHexRegex.test(input)) {
            return false;
        }
    
        const color = tinycolor(input);
        if (!color.isValid()) {
            return false;
        }

        return color.toHexString();
    },

    isRegistrationFeeCategory(categoryName) {
        const regName = (this.CONFIG.TRANSACTION_CATEGORY.SCHOOL_REGISTRATION_FEE || "School Registration Fee").trim();
        const targetName = String(categoryName ?? "").trim();

        return targetName === regName;
    },

    isRefundCategory(categoryName) {
        const refundName = (this.CONFIG.TRANSACTION_CATEGORY.REFUND || "Refund").trim();
        const targetName = String(categoryName ?? "").trim();

        return targetName === refundName;
    },

    getAllTransactionCategories(page = 1) {
      this.searchBtnStatus = false;
      this.isLoading = true;

      axios
        .get("/transactionCategory/list?page=" + page)
        .then((response) => {
          this.categoryData = response.data;
        })
        .catch((err) => {
          if (err.response && err.response.status === 401) {
            this.$store.commit("logout");
            window.location.replace("login");
          } else {
            console.error(err);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    search(page = 1) {
      this.searchBtnStatus = true;
      this.isLoading = true;
      const params = {
        category_name: this.searchData.category_name,
        category_type: this.searchData.category_type,
        is_active: this.searchData.is_active,
      };
      this.searchedData = {
        ...params,
        search_status: this.searchBtnStatus,
      };

      axios
        .get("/transactionCategory/search?page=" + page, { params })
        .then((res) => {
          if (res.data) {
            this.categoryData = res.data;
          }
        })
        .catch((err) => {
          if (err.response && err.response.status === 401) {
            this.$store.commit("logout");
            window.location.replace("login");
          } else {
            console.error(err);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    handlePaginate(page) {
      HandlePaginateService.paginate({
        page,
        isSearch: this.searchBtnStatus,
        searchFn: this.search,
        listFn: this.getAllTransactionCategories,
      });
    },

    reset() {
      this.searchData.category_name = "";
      this.searchData.category_type = null;
      this.searchData.is_active = null;
      this.searchedData = null;
      this.isLoading = true;
      this.getAllTransactionCategories();
    },

    showCreate() {
      this.$router.push({ name: "transactionCategoryCreate" });
    },

    showEdit(id) {
      this.$router.push({ path: `/transactionCategory/edit/${id}` });
    },

    showDetail(id) {
      this.$router.push({ path: `/transactionCategory/detail/${id}` });
    },

    isDeleteAbleCategory(name) {
      return !Object.values(this.CONFIG.TRANSACTION_CATEGORY).includes(name);
    },

    onConfirmDelete(id) {
      if (window.confirm("Are you sure you want to delete?")) {
        this.deleteTransactionCategory(id);
      }
    },

    deleteTransactionCategory(id) {
      axios
        .delete("/transactionCategory/delete/" + id)
        .then(res => {
          if (res.data.success == true) {
            let targetPage = this.currentPage;
            if (this.categoryData?.data?.length === 1 && this.currentPage > 1) {
              targetPage = this.currentPage - 1;
            }
            if (this.searchBtnStatus) {
              this.search(targetPage);
            } else {
              this.getAllTransactionCategories(targetPage);
            }
            this.$notification.success(res.data.message, {
              timer: 3,
              position: "bottomCenter"
            });
          }
        })
        .catch((err) => {
          if (err.response && err.response.status === 401) {
            this.$store.commit("logout");
            window.location.replace("login");
            return;
          }
          const msg =
            (err.response && err.response.data && err.response.data.message) ||
            "Failed to delete transaction category.";
          this.$notification.error(msg, {
            timer: 5,
            position: "bottomCenter",
          });
        });
    },
  },

  mounted() {
    this.isLoading = true;
    this.getAllTransactionCategories();
  },
};
